'use client';

import React from 'react';
import Container from '../Container';
import SectionHeader from '../SectionHeader';
import RenderBodyCopy from '../RenderBodyCopy';
import NextImage from '../NextImage';
import useSlideTextAnimation from '@src/hooks/useSlideTextAnimation';
import { HeroPrimaryPropTypes } from './HeroPrimary.types';
const HeroPrimary: React.FC<HeroPrimaryPropTypes> = ({
  attr,
  id,
  className,
  background,
  pretitle,
  preTitleClassName,
  title,
  titleSlide,
  titleClassName,
  titleAlign,
  imgClassName,
  image,
  bodyCopy,
  childrenClassName,
  bodyCopyClassName,
  children
}) => {
  const {
    slideTextRef
  } = useSlideTextAnimation();
  return <Container id={id} background={background} attr={attr} className={`relative bg-primary md:h-[auto] 2xl:h-[75rem] ${className}`} data-sentry-element="Container" data-sentry-component="HeroPrimary" data-sentry-source-file="HeroPrimary.tsx">
      <SectionHeader className={`relative z-[1] items-start py-[3rem] md:items-start lg:w-[50%] ${titleAlign}`} pretitle={pretitle} preTitleClassName={preTitleClassName} title={title} titleClassName={`text-body-copy--light text-left md:text-left mb-[3.2rem] ${titleClassName}`} align='left' childrenClassName={`text-body-copy--light text-left md:text-left md:text-left max-w-[38rem] ${childrenClassName}`} headingLevel='h1' data-sentry-element="SectionHeader" data-sentry-source-file="HeroPrimary.tsx">
        <>
          {titleSlide && <SectionHeader className={`relative top-[-5.6rem] z-[1] items-start py-[4rem] md:items-start [&>h2>span]:absolute [&>h2>span]:opacity-[0] ${titleAlign}`} title={titleSlide} titleClassName={`!w-full text-body-copy--light text-left md:text-left mb-[3.2rem] leading-[1.3] ${titleClassName}`} titleRef={slideTextRef}></SectionHeader>}
          <RenderBodyCopy bodyCopy={bodyCopy?.json?.content} className={`my-[2rem] ${bodyCopyClassName}`} data-sentry-element="RenderBodyCopy" data-sentry-source-file="HeroPrimary.tsx" />
          {children}
        </>
      </SectionHeader>
      {image && <NextImage className={imgClassName} priority src={image?.url} aspectRatio={image?.width / image?.height} width={image?.width} alt={image?.description} />}
    </Container>;
};
export default HeroPrimary;